module.exports = __webpack_public_path__ + "static/media/1.24156df1.png";